export default async (app, { apiKey, ...options }) => {
  const Pusher = (await import(/* @vite-ignore */ 'pusher-js')).default;
  app.config.globalProperties['$pusher'] = new Pusher(apiKey, options);
};
